<template>
  <div class="container">
    <v-Header></v-Header>
    <h4 class="title">
      <span>&nbsp;&nbsp;咨询详情</span>
    </h4>
    <div class="headContent">
      <el-row>
        <el-col :span="4" :offset="1">
          <el-row>
            <el-col :span="12">申请人工号：</el-col>
            <el-col :span="12">
              <el-input :value="dataCollect.agentCode" readonly></el-input>
              </el-col>
          </el-row>
        </el-col>
        <el-col :span="5" :offset="1">
          <el-row>
            <el-col :span="8">客户姓名：</el-col>
            <el-col :span="16">
              <el-input :value="dataCollect.customerName" readonly></el-input>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="5" :offset="1">
          <el-row>
            <el-col :span="8">客户生日：</el-col>
            <el-col :span="12">
              <el-input :value="dataCollect.customerBirth" readonly></el-input>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="6" :offset="1">
          <el-row>
            <el-col :span="7">证件号码：</el-col>
            <el-col :span="17">
              <el-input :value="dataCollect.idNo" readonly></el-input>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4" :offset="1">
          <el-row>
            <el-col :span="12">申请人姓名：</el-col>
            <el-col :span="12">
              <el-input :value="dataCollect.agentName" readonly></el-input>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="5" :offset="1">
          <el-row>
            <el-col :span="8">客户性别：</el-col>
            <el-col :span="16">
              <el-input :value="dataCollect.customerGender" readonly></el-input>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="5" :offset="1">
          <el-row>
            <el-col :span="8">证件类型：</el-col>
            <el-col :span="12">
              <el-input :value="dataCollect.idType" readonly></el-input>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="6" :offset="1">
          <el-row>
            <el-col :span="7">提交日期：</el-col>
            <el-col :span="17">
              <el-input :value="dataCollect.createDate" readonly></el-input>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4" :offset="1">
          <el-row>
            <el-col :span="12">咨询类型：</el-col>
            <el-col :span="12">
              <el-input :value="dataCollect.consultType" readonly></el-input>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="5" :offset="1">
         <el-row>
            <el-col :span="8">咨询状态：</el-col>
            <el-col :span="16">
              <el-input :value="dataCollect.state" readonly></el-input>
            </el-col>
          </el-row>
        </el-col>
        <!-- <el-col :span="5" :offset="1">
          <el-row>
            <el-col :span="8">提交日期：</el-col>
            <el-col :span="16">
              <el-input :value="contentInfos[0].consultDate" readonly></el-input>
            </el-col>
          </el-row>
        </el-col> -->
      </el-row>
    </div>
    <div class="reply">
      <h4 class="title">
        <span>&nbsp;&nbsp;回复内容</span>
      </h4>
    </div>
    <div class="inputReplay">
      <div>
        <el-table
          ref="multipleTable"
          :data="contentInfos"
          tooltip-effect="dark"
          style="width: 79.1667%;margin-left:4.16667%;"
          border>
        <el-table-column
          align="center"
          prop="consultDate"
          label="咨询时间"
          >
        </el-table-column>
        <el-table-column
          align="center"
          prop="consultContent"
          label="咨询内容"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="replyContent"
          label="回复内容"
        >
        </el-table-column>
        <el-table-column label="咨询图片">
          <template slot-scope="scope">
            <el-button
              type="primary"
               v-if="imgsCollect[scope.$index].length>0"
              @click="handleEdit(scope.row)">
              查看图片
            </el-button>
            <!-- <el-button
              @click="handleEdit(scope.$index, scope.row)">查看图片</el-button> -->
          </template>
        </el-table-column>
        </el-table>
      </div>
      <div class="reversion">
        <el-row>
          <el-col :span="19" :offset="1">
            <el-input resize="none"  type="textarea" :rows="2" placeholder="添加回复内容" v-model="replyContent"></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="19" :offset="1">
            <el-row> 
               <el-col :span="2" :offset="8">
                <el-button type="primary" @click="submit">提交</el-button>
              </el-col>
              <el-col :span="2" :offset="1">
                <el-button type="primary" @click="save">保存</el-button>
              </el-col>
              <el-col :span="2" :offset="1">
                <el-button type="primary" @click="back">返回</el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
      <!-- 确认弹框 -->
      <div class="dialogTip">
        <el-dialog title="提示" center :visible.sync="dialogConfirm" width="30%">
        <span class="headTitle">是否提交</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogConfirm = false">取 消</el-button>
          <el-button type="primary" @click="confrim">确 定</el-button>
        </span>
        </el-dialog>
      </div>
      <!-- 保存弹框 -->
      <div class="dialogTip">
        <el-dialog title="提示" center :visible.sync="dialogSave" width="30%">
        <span class="headTitle">是否保存</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogSave = false">取 消</el-button>
          <el-button type="primary" @click="saveConfirm">确 定</el-button>
        </span>
        </el-dialog>
      </div>
    <!-- 图片展示 -->
    <div class="dialogWh">
      <el-dialog :visible.sync="showImg" v-if="show">
        <div v-for="item in imgs" :key="item" class="dialogImg">
          <img v-image-preview :src="item"/>
        </div>
      </el-dialog>
    </div>
    </div>
  </div>
</template>
<script>
import vHeader from '@/layout/Header.vue'
import api from '@/modules/api.js';
import url from '@/modules/url.js';
export default {
  name:'ConsultDetail',
  data(){
    return {
      replyContent:'', //回复消息
      consultContentId:'',//提问id
      consultNo:'', //保单号
      dataCollect:{}, //接收数据
      contentInfos: [],
      dialogTableVisible:false,
      imgs:[],
      showImg:false,
      show:false,
      showImgBtn:false,
      dialogConfirm:false,
      imgsCollect:[],
      dialogSave:false
    }
  },
  methods:{
    getConsultDetailPC(){
      let param = {
        consultNo:this.consultNo
      }
      api.post(url.getConsultDetailPC, param, res=> {
        if(res.result.isSuccess){
          this.dataCollect.consultType = res.data.consultType
          this.dataCollect.idType = res.data.idType
          this.dataCollect.agentCode = res.data.agentCode
          this.dataCollect.customerGender = res.data.customerGender
          this.dataCollect.agentName = res.data.agentName
          this.dataCollect.consultNo = res.data.consultNo
          this.dataCollect.idNo = res.data.idNo
          this.dataCollect.customerName = res.data.customerName
          this.dataCollect.createDate = res.data.createDate
          this.contentInfos = res.data.contentInfos
          this.dataCollect.modifyState = res.data.modifyState
          this.dataCollect.state = res.data.state
          this.dataCollect.customerBirth = res.data.customerBirth
          this.contentInfos.forEach(item=>{
            this.imgsCollect.push(item.images)
          })
          this.replyContent = res.data.replyCache
        }
      });
    },
    submit(){
      if(!this.replyContent){
        this.$message.error('请输入回复内容')
        return false
      }
      this.dialogConfirm = true
    },
    //确认提交
    confrim(){
      this.contentInfos.forEach((item)=>{
        this.consultContentId = item.contentId
      })
      let params = {
        consultContentId:this.consultContentId,
        replyContent:this.replyContent,
        replyType:'SUBMIT'
      }
      api.post(url.replyConsult, params, res=> {
        if(res.result.isSuccess){
          this.dialogConfirm = false
          this.getConsultDetailPC()
          this.replyContent = ''
        }else{
          this.$message.error(res.result.error)
          this.dialogConfirm = false
        }
      });
    },
    //点击查看图片
    handleEdit(row){
      // console.log(row,'ddd')
      this.showImg = true
      this.show = true
      this.imgs = row.images
    },
    back(){
      let getList = this.$route.params.getNochange
      let req = this.$route.params.getList
      // console.log(req,'qqqq')
      let customerName = this.$route.params.customerName
      let applyName = this.$route.params.applyName
      let applyCode = this.$route.params.applyCode
      let dateStart = this.$route.params.dateStart
      // console.log(dateStart,'dateStart')
      this.$router.push({
        name:'clientConsult',
        params:{
          req,
          customerName,
          applyName,
          applyCode,
          getList,
          dateStart,
        }
      })
    },
    save(){
      if(!this.replyContent){
        this.$message.error('请输入内容')
        return false
      }
      this.dialogSave = true
    },
    saveConfirm(){
      this.contentInfos.forEach((item)=>{
        this.consultContentId = item.contentId
      })
      let params = {
        consultContentId:this.consultContentId,
        replyContent:this.replyContent,
        replyType:'SAVE'
      }
      api.post(url.replyConsult, params, res=> {
        if(res.result.isSuccess){
          this.dialogSave = false
          this.getConsultDetailPC()
        }else{
          this.$message.error(res.result.error)
          this.dialogSave = false
        }
      });
    }
  },
  mounted(){
    this.getConsultDetailPC()
  },
  created(){
    // console.log(this.$route.params.getList,'getListCopy')
    if(sessionStorage.getItem('consultNo')){
        this.consultNo = JSON.parse(decodeURIComponent(sessionStorage.getItem('consultNo')))
      }
  },
  components:{
    vHeader
  }
}
</script>
<style scoped>
.container /deep/ .el-main {
  background: #fff;
}
.title {
  background: #e0e0e0;
  height: 50px;
  line-height: 50px;
  margin: 0;
}
.headContent{
  padding: 20px 0 20px 0;
  line-height: 55px;
  background: #fff;
}
.headContent >>> .el-row{
  height: 55px;
}
.img {
  background: #fff;
}
.img >>> .el-row{
  line-height: 55px;
}
.img >>> .el-col-18{
  margin-top:15px;
}
.content{
  padding:0 30px;
  background: #fff;
}
.contentTitle{
  height: 50px;
  line-height: 50px;
  margin: 0;
}
.contentTip{
  padding: 10px 0 10px 100px;
}
.contentTip p{
  font-size: 13px;
}
.contentTip p>span{
  display: inline;
  margin-right: 10px;
}
.container{
  background: #fff ;
  height: 100vh;
}
.container >>> .el-dialog{
  width: 400px;
  height: 300px;
}
.container >>> .el-textarea__inner{
  height: 70px;
}
.container >>> .el-dialog__footer{
  width: 100%;
  display: flex;
  justify-content:space-around;
}
.container >>>  .el-dialog__body{
  padding:10px 20px;
}
/* .tableBottom{
  padding-bottom: 20px;
} */
.reply {
  padding-bottom: 20px;
}

.dialogue{
  background: #fff;
  width: 100%;height: 30vh;
  overflow-y:auto ;
  padding-top: 20px;
}
.left{
  margin-left:4.16667%;
  width: 45.83333%;height: auto;
  border-radius: 4px;
  border:1px solid #DCDFE6;
  color:#606266;
  margin-bottom: 10px;
  padding: 10px 10px 10px 10px;
  float: left;
}
.right{
  width: 45.83333%;height: auto;
  line-height: 20px;
  border-radius: 4px;
  border:1px solid #DCDFE6;
  color:#606266;
  margin-right: 4.16667%;
  margin-top: 10px;
  padding: 10px 10px 10px 10px;
  float: right;
}
.inputReplay{
  background: #fff;
  width: 100%;height: auto;
  padding-bottom: 20px;
}
.inputReplay >>> .el-row{
  height: 70px;
  line-height: 70px;
}
.inputReplay >>> .el-button{
  height: 40px;
}
.inputReplay >>> .el-table .cell{
  text-align: center;
}
.reversion{
  margin-top: 40px;
}
.dialogImg {
  display: inline-block;
}
.dialogImg img{
  margin-right: 10px;
  width: 100px;height: auto;
}
.dialogWh >>> .el-dialog {
  z-index:2000;
  min-height: 400px;
  width: 600px;height:auto;
}
.dialogTip >>> .el-dialog{
  height: 200px;
}
.headTitle{
  display: block;
  text-align: center;
}
.dialogTip >>> .el-dialog__footer{
  padding-top: 20px;
}
</style>
<style>
body /deep/ .vue-directive-image-previewer{
  z-index: 10000;
}
body /deep/ .vue-directive-image-previewer-body{
  z-index: 3000;
}
body /deep/ .vue-directive-image-previewer-body img{
  z-index: 3000;
}
</style>


// WEBPACK FOOTER //
// src/pages/client/consultDetail.vue